
import FoodOverviewGrid from "../components/FoodOverviewGrid-foodfacts";
import { colors, space, radius, borders } from "../design/tokens";

import {
  Screen,
  Content,
  Card,
  TextInput,
  Button,
  Text,
  Row
} from "../components/layout";

export default function FoodPage() {
    return(
        <>
            <Screen>
                <Content>
                    <Card style={{
                    padding: space.sm,
                    gap: space.lg
                    }}
                    >
                        <FoodOverviewGrid />

                    </Card>
                </Content>
            </Screen >
        </>
    )
}